// extracted by mini-css-extract-plugin
module.exports = {"crossStyle":"errorModal_crossStyle__2aYJ1","modalStyle":"errorModal_modalStyle__3cgbS"};